import { render, staticRenderFns } from "./OfertaBoasVindas.vue?vue&type=template&id=edfe70be&scoped=true"
import script from "./OfertaBoasVindas.vue?vue&type=script&lang=js"
export * from "./OfertaBoasVindas.vue?vue&type=script&lang=js"
import style0 from "./OfertaBoasVindas.vue?vue&type=style&index=0&id=edfe70be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe70be",
  null
  
)

export default component.exports